import React from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenExpired } from './auth'; // import helper

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('jwt_token');

  if (!token || isTokenExpired(token)) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;
